import { HiMoon, HiSun } from 'react-icons/hi'
import { useTheme } from '@/hooks/useTheme'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

/**
 * Composant toggle pour basculer entre thème clair/sombre
 * Accessible avec animations fluides
 */
const ThemeToggle = ({ className }) => {
  const { t } = useTranslation()
  const [theme, toggleTheme] = useTheme() // ✅ useTheme retourne un tableau [theme, toggleTheme]
  const isDark = theme === 'dark'

  return (
    <button
      onClick={toggleTheme}
      className={classNames(
        'relative p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500',
        'hover:bg-gray-100 dark:hover:bg-gray-800',
        className
      )}
      aria-label={isDark ? t('settings.lightMode') : t('settings.darkMode')}
      title={isDark ? t('settings.lightMode') : t('settings.darkMode')}
    >
      {/* Animation de transition entre icônes */}
      <div className="relative w-5 h-5">
        <HiSun
          className={classNames(
            'absolute inset-0 transition-all duration-300',
            isDark ? 'opacity-0 rotate-90 scale-0' : 'opacity-100 rotate-0 scale-100',
            'text-yellow-500'
          )}
        />
        <HiMoon
          className={classNames(
            'absolute inset-0 transition-all duration-300',
            isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-0',
            'text-blue-400'
          )}
        />
      </div>
    </button>
  )
}

export default ThemeToggle

